import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'contexts/auth-context';
import { NotificationProvider } from 'contexts/notification-context';
import { Routes } from "components/Routes";

function App() {
    return (
        <BrowserRouter>
            <NotificationProvider>
                <AuthProvider>
                    <Routes />
                </AuthProvider>
            </NotificationProvider>
        </BrowserRouter>
    );
}

export default App;
